var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoYahooDarkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 46,
    viewBox: "0 0 152 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 161.896,
    height: 37.833,
    fill: "#242e45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 125.768,
    height: 29.312,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-yahoo",
    transform: "translate(-4.948 4.084)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-yahoo-2",
    "data-name": "logo-yahoo",
    transform: "translate(18.064 4.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-yahoo-3",
    "data-name": "logo-yahoo",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Yahoo__Messenger_Logo__2013-2018_",
    "data-name": "Yahoo!_Messenger_Logo_(2013-2018)",
    transform: "translate(0.176 0.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M22.734.715h0a2.084,2.084,0,0,0-.411-.059A1.727,1.727,0,0,0,20.5,2.594c-.528,6.929-1.116,13.858-2.055,20.435h0a2.186,2.186,0,0,1,1.409.235h0c1.057-6.694,3.582-16.735,4.228-19.613a5.042,5.042,0,0,0,.235-1.233A1.57,1.57,0,0,0,22.734.715Z",
    transform: "translate(101.109 -0.362)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M17.044,1.032h0a3.886,3.886,0,0,1-2.7,0h0c-3.054,7.751-6.636,16.5-9.806,23.019h0a8.02,8.02,0,0,1,3.758,0h0c.822-2.055,1.762-4.4,2.642-6.753h0c3.112-.118,6.283-.118,9.4,0,.881,2.231,1.762,4.522,2.642,6.753h0a7.591,7.591,0,0,1,3.817,0h0C24.56,19.705,19.98,8.49,17.044,1.032ZM15.693,5.025c1.292,3.523,2.642,7.105,4.11,10.687h0c-2.7.117-5.461.117-8.162,0h0C13.285,11.484,14.871,7.374,15.693,5.025Z",
    transform: "translate(12.904 2.022)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M15.2,17.293h0C18.367,11.714,23.652,2.554,25.12.616h0a8.631,8.631,0,0,1-3.876,0h0c-1.116,2.055-5.109,8.573-7.634,12.8C11.027,9.131,7.973,4.139,5.977.616h0a7.023,7.023,0,0,1-3.817,0h0c3.112,4.756,8.162,13.741,9.865,16.677L11.79,29.624h0a15.086,15.086,0,0,1,1.82-.176,12.515,12.515,0,0,1,1.82.176h0Z",
    transform: "translate(-2.16 -0.616)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M8.288,4.168Z",
    transform: "translate(36.692 21.904)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M23.022.992h0c-8.1,0-12.39,5.167-12.39,11.862,0,7.34,4.639,11.744,12.39,11.744,8.338,0,12.449-5.05,12.449-11.686C35.471,5.455,30.6.992,23.022.992Zm.059,22.314c-5.4,0-8.573-3.876-8.573-10.452,0-7.4,3.934-10.394,8.4-10.452h.235c4.991,0,8.633,3.406,8.633,10.452C31.655,19.9,28.014,23.306,23.081,23.306Z",
    transform: "translate(51.554 1.768)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M28.469.8h0C20.366.8,14.2,5.38,14.2,13.954c0,7.047,4.11,13.212,14.328,13.212,8.691,0,14.328-4.756,14.328-13.095C42.856,6.2,37.571.8,28.469.8ZM18.017,13.895c0-8.984,5.52-11.686,10.452-11.686,6.107,0,10.57,3.7,10.57,11.862,0,8.867-5.4,11.744-10.57,11.744C23.008,25.815,18.017,22.586,18.017,13.895Z",
    transform: "translate(74.176 0.551)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M20,4.08a1.768,1.768,0,0,0-1.82,1.879c0,1.174.939,1.762,2.055,1.762A1.722,1.722,0,0,0,22,5.842C22.06,4.785,21.179,4.08,20,4.08Z",
    transform: "translate(99.435 21.346)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.192,4.344Z",
    transform: "translate(99.485 23.02)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3.472,4.568Z",
    transform: "translate(6.158 24.44)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M27.675,1.032h0a8.379,8.379,0,0,1-3.817,0h0c.176,3.582.294,7.164.294,10.746q-6.43.176-12.86,0c0-3.582.117-7.164.294-10.746h0a8.379,8.379,0,0,1-3.817,0h0c.352,7.692.294,15.326,0,22.96h0a8.379,8.379,0,0,1,3.817,0h0c-.176-3.582-.294-7.105-.294-10.687q6.43-.088,12.86,0c0,3.582-.117,7.105-.294,10.687h0a8.379,8.379,0,0,1,3.817,0h0C27.381,16.358,27.381,8.724,27.675,1.032Z",
    transform: "translate(33.396 2.022)",
    fill: "#242e45"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYahooDarkBlue);
export default __webpack_public_path__ + "static/media/logo-yahoo-dark-blue.3bd2a66b526b307258eb91c58f2ab11e.svg";
export { ForwardRef as ReactComponent };